import { Member } from '@vista-digital/ocapi-types/v1'
import { cancelOrder, orderDomainStore } from '@vista-digital/occ-domain'
import { observable, runInAction } from 'mobx'

class MemberService {
    memberObs = observable.box(null as Member)

    onSignedOut() {
        console.debug('User signed out, clearing orders, refreshing...')
        window.location.reload()
    }

    setMember(member: Member) {
        runInAction(() => {
            this.memberObs.set(member)
        })

        return true
    }
    
    getMember = () => this.memberObs.get()
}

export const memberService = new MemberService()
